import * as React from 'react';
import {observer} from "mobx-react-lite";
import {Spinner} from "react-bootstrap";

const Backdrop = observer(function Backdrop(props: {hidden: boolean, children?: any}) {
    return <div className="backdrop-loading" hidden={props.hidden}>
        {props.children}
        <Spinner hidden={props.hidden} animation={"border"} role="status">
            <span className="sr-only">Loading...</span>
        </Spinner>
    </div>
});

export default Backdrop